module.exports = __webpack_public_path__ + "img/scanpay.e9da3e92.png";